/* BAe Online Mock Exams — exam engine (no questions live in this file) */
(function () {
  'use strict';
  var app = document.getElementById('bae-mock-app');
  if (!app) return;

  var DOMAINS = {
    A: 'Behaviorism and Philosophical Foundations',
    B: 'Concepts and Principles',
    C: 'Measurement, Data Display, and Interpretation',
    D: 'Experimental Design',
    E: 'Ethical and Professional Issues',
    F: 'Behavior Assessment',
    G: 'Behavior-Change Procedures',
    H: 'Selecting and Implementing Interventions',
    I: 'Personnel Supervision and Management'
  };
  var TONES = { A: 'lav', B: 'sky', C: 'mint', D: 'rose', E: 'kraft', F: 'lav', G: 'sky', H: 'mint', I: 'rose' };
  var LETTERS = ['A', 'B', 'C', 'D'];
  var CUST = app.dataset.customer || 'guest';
  var MINUTES = app.dataset.minutes === '0' ? 0 : (parseInt(app.dataset.minutes, 10) || 240);
  var PARK = { grad: app.dataset.parkGrad, clip: app.dataset.parkClip, det: app.dataset.parkDet };

  function load(id) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; }
  }
  /* Optional per-product config; defaults reproduce the BAe mock exams exactly. */
  var CFG = load('mk-config') || {};
  function cfg(k, d) { return CFG[k] !== undefined ? CFG[k] : d; }
  if (CFG.domains) DOMAINS = CFG.domains;
  if (CFG.tones) TONES = CFG.tones;
  var PREFIX = cfg('prefix', 'bae-mock');
  var FORM_DEFS = cfg('forms', [
    { id: 'A', el: 'bae-form-A', name: 'Form A', meta: '{n} questions · all nine domains · every task on the 6th-edition outline' },
    { id: 'B', el: 'bae-form-B', name: 'Form B', meta: '{n} questions · all nine domains · every task on the 6th-edition outline' }
  ]);
  var FORMS = {}, FNAME = {}, FMETA = {};
  FORM_DEFS.forEach(function (f) { FORMS[f.id] = load(f.el) || []; FNAME[f.id] = f.name; FMETA[f.id] = f.meta; });
  function fname(f) { return FNAME[f] || ('Form ' + f); }
  function durLabel(min) { return min % 60 === 0 ? (min / 60) + (min === 60 ? ' hour' : ' hours') : min + ' minutes'; }
  var MODES = cfg('modes', [
    { mode: 'exam', label: 'Exam mode · ' + durLabel(MINUTES) },
    { mode: 'study', label: 'Study mode' }
  ]);
  var MODE_NAME = cfg('modeNames', { exam: 'exam mode', study: 'study mode' });

  /* ---------- storage (per customer, per form) ---------- */
  function key(form) { return PREFIX + ':' + CUST + ':' + form; }
  var HKEY = PREFIX + '-hist:' + CUST;
  function get(k, fallback) {
    try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function drop(k) { try { localStorage.removeItem(k); } catch (e) {} }

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dom(t) { return t.split('.')[0]; }
  function pct(a, b) { return b ? Math.round((a / b) * 100) : 0; }
  function fmtTime(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
    return h + ':' + (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }
  function fmtDate(ts) {
    try { return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; }
  }

  var S = null;          // active session state
  var FORM = null;       // active form letter
  var timerId = null;
  var reviewFilter = 'all';

  function save() { if (S && FORM) put(key(FORM), S); }

  /* ============================== HOME ============================== */
  function home() {
    stopTimer();
    S = null; FORM = null;
    var hist = get(HKEY, []);
    var html = '<div class="mk-home">' +
      '<div class="mk-home__head"><div>' +
      '<span class="tab-chip tone-sky">' + esc(cfg('chip', 'BAe · online')) + '</span>' +
      '<h1 class="h2">' + esc(cfg('title', 'Your mock exams')) + '</h1>' +
      '<p class="lede">' + cfg('lede', 'Two full-length forms, 185 questions each, weighted like the real exam. Take them in exam mode for a true dress rehearsal, or in study mode to learn as you go.') + '</p>' +
      '</div><img class="mk-home__park" src="' + esc(PARK.clip) + '" alt="" width="180" height="180"></div>' +
      '<div class="mk-forms">';
    FORM_DEFS.map(function (d) { return d.id; }).forEach(function (f) {
      var st = get(key(f), null);
      var n = FORMS[f].length;
      var last = hist.filter(function (h) { return h.form === f; }).slice(-1)[0];
      var status, actions;
      if (st && !st.submitted) {
        var answered = Object.keys(st.answers).length;
        status = '<p class="mk-status mk-status--live">In progress · ' + esc(MODE_NAME[st.mode] || st.mode) + ' · ' + answered + ' of ' + n + ' answered' +
          (st.deadline ? ' · ' + fmtTime(st.deadline - Date.now()) + ' left' : '') + '</p>';
        actions = '<button class="button" data-act="resume" data-form="' + f + '">Resume</button>' +
          '<button class="button button--secondary" data-act="restart" data-form="' + f + '">Start over</button>';
      } else {
        status = last ? '<p class="mk-status">Last score: <strong>' + last.score + ' / ' + last.total + ' (' + pct(last.score, last.total) + '%)</strong> · ' + fmtDate(last.date) + '</p>'
                      : '<p class="mk-status">Not started yet</p>';
        actions = MODES.map(function (m, k) {
            return '<button class="button' + (k ? ' button--secondary' : '') + '" data-act="start" data-mode="' + m.mode + '" data-form="' + f + '">' + esc(m.label) + '</button>';
          }).join('') +
          (st && st.submitted ? '<button class="mk-link" data-act="results" data-form="' + f + '">Review last results</button>' : '');
      }
      html += '<article class="mk-form card-taped card-taped--flat">' +
        '<h2 class="h3">' + esc(fname(f)) + '</h2>' +
        '<p class="muted">' + esc((FMETA[f] || '{n} questions').replace('{n}', n)) + '</p>' +
        status + '<div class="button-row">' + actions + '</div></article>';
    });
    html += '</div>';

    var how = cfg('how', [
      '<strong>Exam mode</strong> works like test day: ' + durLabel(MINUTES) + ', no explanations until you finish. The clock keeps running if you close the tab, so plan one sitting. When time runs out, the exam submits itself.',
      '<strong>Study mode</strong> has no clock. Check each answer and read the explanation before you move on.',
      'Your progress saves on this device and browser. Use the same one to resume.',
      'Shortcuts: <kbd>1</kbd>–<kbd>4</kbd> or <kbd>A</kbd>–<kbd>D</kbd> to answer, <kbd>←</kbd> <kbd>→</kbd> to move, <kbd>F</kbd> to flag.'
    ]);
    html += '<div class="mk-how"><h2 class="h3">Before you start</h2><ul>' + how.map(function (h) { return '<li>' + h + '</li>'; }).join('') + '</ul></div>';

    if (hist.length) {
      html += '<div class="mk-hist"><h2 class="h3">Your attempts</h2><table class="mk-table"><thead><tr><th>Date</th><th>Form</th><th>Mode</th><th>Score</th><th>Weakest domain</th></tr></thead><tbody>';
      hist.slice().reverse().forEach(function (h) {
        html += '<tr><td>' + fmtDate(h.date) + '</td><td>' + esc(fname(h.form)) + '</td><td>' + esc(MODE_NAME[h.mode] || h.mode) + '</td><td>' + h.score + ' / ' + h.total + ' (' + pct(h.score, h.total) + '%)</td><td>' + (h.weakest ? esc(h.weakest + ' · ' + DOMAINS[h.weakest]) : '') + '</td></tr>';
      });
      html += '</tbody></table></div>';
    }
    html += '<p class="mk-fine">' + esc(cfg('fine', 'An independent study aid, not affiliated with or endorsed by the Behavior Analyst Certification Board. Questions are original practice items, not actual exam questions.')) + '</p></div>';
    app.innerHTML = html;
    window.scrollTo(0, app.getBoundingClientRect().top + window.scrollY - 90);
  }

  /* ============================== SESSION ============================== */
  function start(form, mode) {
    FORM = form;
    S = { mode: mode, answers: {}, flags: {}, checked: {}, cur: 0, started: Date.now(),
          deadline: mode === 'exam' && MINUTES ? Date.now() + MINUTES * 60000 : null, submitted: false };
    save();
    question();
  }
  function resume(form) {
    FORM = form; S = get(key(form), null);
    if (!S) return home();
    if (S.submitted) return results();
    if (S.deadline && Date.now() >= S.deadline) return submit(true);
    question();
  }

  function startTimer() {
    stopTimer();
    if (!S || !S.deadline) return;
    var el = document.getElementById('mk-timer');
    function tick() {
      var left = S.deadline - Date.now();
      if (el) {
        el.textContent = fmtTime(left);
        el.classList.toggle('is-low', left < 15 * 60000);
      }
      if (left <= 0) { stopTimer(); submit(true); }
    }
    tick(); timerId = setInterval(tick, 1000);
  }
  function stopTimer() { if (timerId) { clearInterval(timerId); timerId = null; } }

  function question() {
    var Q = FORMS[FORM], i = S.cur, q = Q[i], n = Q.length;
    var chosen = S.answers[i], study = S.mode === 'study', checked = study && S.checked[i];
    var answered = Object.keys(S.answers).length;
    var html = '<div class="mk-exam">' +
      '<div class="mk-bar">' +
        '<div class="mk-bar__left"><strong>' + esc(fname(FORM)) + '</strong><span class="muted"> · ' + esc(MODE_NAME[S.mode] || S.mode) + '</span></div>' +
        '<div class="mk-bar__mid">Question <strong>' + (i + 1) + '</strong> of ' + n + '<span class="mk-bar__count muted"> · ' + answered + ' answered</span></div>' +
        '<div class="mk-bar__right">' +
          (!S.deadline ? '' : '<span class="mk-timer" id="mk-timer" aria-live="off" title="Time left">' + fmtTime(S.deadline - Date.now()) + '</span>') +
          '<button class="mk-btn" data-act="map" aria-haspopup="dialog">Question map</button>' +
          '<button class="mk-btn mk-btn--ink" data-act="finish">Finish</button>' +
        '</div>' +
      '</div>' +
      '<div class="mk-progress" aria-hidden="true"><span style="width:' + pct(answered, n) + '%"></span></div>' +
      '<article class="mk-q card-taped card-taped--flat">' +
        '<div class="mk-q__meta">' +
          (study ? '<span class="tab-chip tone-' + TONES[dom(q.t)] + '">' + dom(q.t) + '</span><span class="muted">' + esc(q.t) + ' · ' + esc(DOMAINS[dom(q.t)]) + '</span>' : '<span class="muted">Question ' + (i + 1) + '</span>') +
          '<label class="mk-flag"><input type="checkbox" data-act="flag"' + (S.flags[i] ? ' checked' : '') + '> Flag for review</label>' +
        '</div>' +
        '<h2 class="mk-q__stem" id="mk-stem">' + esc(q.q) + '</h2>' +
        '<div class="mk-opts" role="radiogroup" aria-labelledby="mk-stem">';
    q.o.forEach(function (o, k) {
      var cls = 'mk-opt';
      if (chosen === k) cls += ' is-chosen';
      if (checked) { if (k === q.c) cls += ' is-right'; else if (chosen === k) cls += ' is-wrong'; }
      html += '<label class="' + cls + '"><input type="radio" name="mk-opt" value="' + k + '"' + (chosen === k ? ' checked' : '') + (checked ? ' disabled' : '') + '>' +
        '<span class="mk-opt__letter">' + LETTERS[k] + '</span><span class="mk-opt__text">' + esc(o) + '</span></label>';
    });
    html += '</div>';
    if (checked) {
      var ok = chosen === q.c;
      html += '<div class="mk-explain ' + (ok ? 'is-right' : 'is-wrong') + '" role="status"><p class="mk-explain__verdict">' + (ok ? 'Correct.' : 'Not this time. The answer is ' + LETTERS[q.c] + '.') + '</p><p>' + esc(q.e) + '</p></div>';
    }
    html += '<div class="mk-nav">' +
      '<button class="button button--secondary" data-act="prev"' + (i === 0 ? ' disabled' : '') + '>← Previous</button>' +
      (study && !checked ? '<button class="button" data-act="check"' + (chosen === undefined ? ' disabled' : '') + '>Check answer</button>' : '') +
      (i < n - 1 ? '<button class="button' + (study && !checked ? ' button--secondary' : '') + '" data-act="next">Next →</button>'
                 : '<button class="button" data-act="finish">Finish and see results</button>') +
      '</div></article></div>';
    app.innerHTML = html;
    startTimer();
    var top = app.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > top) window.scrollTo(0, top);
  }

  function choose(k) {
    if (S.mode === 'study' && S.checked[S.cur]) return;
    S.answers[S.cur] = k; save(); question();
  }
  function go(d) {
    var n = FORMS[FORM].length, j = S.cur + d;
    if (j < 0 || j >= n) return;
    S.cur = j; save(); question();
  }

  /* ---------- modal (map + confirm) ---------- */
  function modal(inner, label) {
    closeModal();
    var m = document.createElement('div');
    m.className = 'mk-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', label);
    m.innerHTML = '<div class="mk-modal__box">' + inner + '</div>';
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(); });
    document.body.appendChild(m);
    var f = m.querySelector('button'); if (f) f.focus();
  }
  function closeModal() { var m = document.querySelector('.mk-modal'); if (m) m.remove(); }

  function map() {
    var Q = FORMS[FORM], html = '<div class="mk-modal__head"><h2 class="h3">Question map</h2><button class="mk-btn" data-act="close">Close</button></div>' +
      '<p class="mk-legend"><span class="mk-cell is-ans"></span> answered <span class="mk-cell is-flag"></span> flagged <span class="mk-cell"></span> not answered</p><div class="mk-grid">';
    Q.forEach(function (_, i) {
      var cls = 'mk-cell';
      if (S.answers[i] !== undefined) cls += ' is-ans';
      if (S.flags[i]) cls += ' is-flag';
      if (i === S.cur) cls += ' is-cur';
      html += '<button class="' + cls + '" data-act="jump" data-i="' + i + '" aria-label="Question ' + (i + 1) + '">' + (i + 1) + '</button>';
    });
    html += '</div>';
    modal(html, 'Question map');
  }

  function confirmFinish() {
    var n = FORMS[FORM].length, a = Object.keys(S.answers).length, fl = Object.keys(S.flags).filter(function (k) { return S.flags[k]; }).length;
    var html = '<h2 class="h3">Finish ' + esc(fname(FORM)) + '?</h2>' +
      '<p>You’ve answered <strong>' + a + ' of ' + n + '</strong>.' + (n - a ? ' <strong>' + (n - a) + '</strong> are blank and will count as wrong.' : '') + (fl ? ' You flagged <strong>' + fl + '</strong> to review.' : '') + '</p>' +
      '<div class="button-row"><button class="button" data-act="submit">Finish and score it</button><button class="button button--secondary" data-act="close">Keep going</button></div>';
    modal(html, 'Finish exam');
  }

  function submit(timeUp) {
    closeModal(); stopTimer();
    var Q = FORMS[FORM], score = 0, by = {};
    Q.forEach(function (q, i) {
      var d = dom(q.t); by[d] = by[d] || [0, 0]; by[d][1]++;
      if (S.answers[i] === q.c) { score++; by[d][0]++; }
    });
    var weakest = Object.keys(by).sort(function (x, y) { return by[x][0] / by[x][1] - by[y][0] / by[y][1]; })[0];
    S.submitted = true; S.finished = Date.now(); S.timeUp = !!timeUp; S.score = score;
    save();
    var hist = get(HKEY, []);
    hist.push({ form: FORM, mode: S.mode, date: S.finished, score: score, total: Q.length, weakest: weakest });
    put(HKEY, hist.slice(-30));
    reviewFilter = 'all';
    results();
  }

  /* ---------- optional email gate for the review (free diagnostic) ---------- */
  var LKEY = PREFIX + ':lead';
  function leadOK() { return !!get(LKEY, false); }
  function leadBox() {
    var t = document.getElementById(CFG.lead.el || 'mk-lead');
    return '<div class="mk-lead card-taped card-taped--flat">' + (t ? t.innerHTML : '') + '</div>';
  }

  /* ============================== RESULTS ============================== */
  function results() {
    stopTimer();
    var Q = FORMS[FORM], by = {}, missedTasks = {}, score = 0;
    Q.forEach(function (q, i) {
      var d = dom(q.t); by[d] = by[d] || [0, 0]; by[d][1]++;
      if (S.answers[i] === q.c) { score++; by[d][0]++; } else { missedTasks[q.t] = (missedTasks[q.t] || 0) + 1; }
    });
    var order = Object.keys(DOMAINS);
    var weakest = order.slice().sort(function (x, y) { return by[x][0] / by[x][1] - by[y][0] / by[y][1]; }).slice(0, 3);
    var p = pct(score, Q.length);
    var html = '<div class="mk-results">' +
      (S.timeUp ? '<p class="mk-banner">Time ran out, so ' + esc(fname(FORM)) + ' was submitted automatically.</p>' : '') +
      '<div class="mk-score card-taped">' +
        '<div><span class="tab-chip tone-mint">' + esc(fname(FORM)) + ' · ' + esc(MODE_NAME[S.mode] || S.mode) + '</span>' +
        '<p class="mk-score__big">' + score + '<span> / ' + Q.length + '</span></p>' +
        '<p class="mk-score__pct">' + p + '% correct</p>' +
        '<p class="muted">' + esc(cfg('scoreNote', 'The real exam reports a scaled pass or fail, not a percentage, so no practice score can promise a result. Use this as a map: your points are hiding in the domains below.')) + '</p></div>' +
        '<img src="' + esc(PARK.grad) + '" alt="" width="200" height="200" class="mk-score__park">' +
      '</div>' +
      '<h2 class="h3">By domain</h2><div class="mk-domains">';
    order.forEach(function (d) {
      if (!by[d]) return;
      var dp = pct(by[d][0], by[d][1]);
      html += '<div class="mk-dom' + (weakest.indexOf(d) > -1 ? ' is-weak' : '') + '">' +
        '<span class="tab-chip tone-' + TONES[d] + '">' + d + '</span>' +
        '<span class="mk-dom__name">' + esc(DOMAINS[d]) + '</span>' +
        '<span class="mk-dom__bar" aria-hidden="true"><span style="width:' + dp + '%"></span></span>' +
        '<span class="mk-dom__n">' + by[d][0] + '/' + by[d][1] + ' · ' + dp + '%</span></div>';
    });
    html += '</div>';
    var tasks = Object.keys(missedTasks).sort(function (a, b) { return missedTasks[b] - missedTasks[a] || a.localeCompare(b, undefined, { numeric: true }); });
    html += '<div class="mk-next"><h2 class="h3">Study next</h2><p>Your three lowest domains: <strong>' + weakest.map(function (d) { return d + ' (' + DOMAINS[d] + ')'; }).join(', ') + '</strong>.</p>' +
      (!cfg('showTasks', true) ? '' : tasks.length ? '<p class="muted">Tasks you missed most, with the number missed:</p><p class="mk-tasks">' + tasks.slice(0, 18).map(function (t) { return '<span>' + esc(t) + ' ×' + missedTasks[t] + '</span>'; }).join('') + '</p>' : '<p>You didn’t miss a single task. Park is speechless.</p>') +
      '</div>';

    var CTA = cfg('cta', null);
    if (CTA) {
      html += '<div class="mk-cta card-taped card-taped--flat"><div><h2 class="h3">' + esc(CTA.title) + '</h2><p>' + CTA.text + '</p>' +
        '<div class="button-row"><a class="button" href="' + esc(CTA.url) + '">' + esc(CTA.button) + '</a></div></div>' +
        '<img src="' + esc(PARK.det) + '" alt="" width="160" height="160" class="mk-cta__park"></div>';
    }
    if (CFG.lead && !leadOK()) {
      html += '<h2 class="h3" id="mk-review">Review every question</h2>' + leadBox() +
        '<div class="button-row"><button class="button button--secondary" data-act="retake" data-form="' + FORM + '">' + esc(cfg('retakeLabel', 'Retake ' + fname(FORM))) + '</button></div></div>';
      app.innerHTML = html;
      window.scrollTo(0, app.getBoundingClientRect().top + window.scrollY - 90);
      return;
    }
    if (CFG.lead && CFG.lead.reward) {
      html += '<p class="mk-banner mk-banner--ok">' + CFG.lead.reward + '</p>';
    }

    var counts = { all: Q.length, missed: 0, flagged: 0, blank: 0 };
    Q.forEach(function (q, i) {
      if (S.answers[i] !== q.c) counts.missed++;
      if (S.flags[i]) counts.flagged++;
      if (S.answers[i] === undefined) counts.blank++;
    });
    html += '<h2 class="h3" id="mk-review">Review every question</h2><div class="mk-filters" role="group" aria-label="Filter questions">' +
      [['all', 'All'], ['missed', 'Missed'], ['flagged', 'Flagged'], ['blank', 'Blank']].map(function (f) {
        return '<button class="mk-btn' + (reviewFilter === f[0] ? ' mk-btn--ink' : '') + '" data-act="filter" data-f="' + f[0] + '" aria-pressed="' + (reviewFilter === f[0]) + '">' + f[1] + ' (' + counts[f[0]] + ')</button>';
      }).join('') + '</div><div class="mk-review">';
    Q.forEach(function (q, i) {
      var a = S.answers[i], ok = a === q.c;
      if (reviewFilter === 'missed' && ok) return;
      if (reviewFilter === 'flagged' && !S.flags[i]) return;
      if (reviewFilter === 'blank' && a !== undefined) return;
      html += '<details class="mk-rev ' + (ok ? 'is-right' : 'is-wrong') + '"><summary><span class="mk-rev__n">' + (i + 1) + '</span>' +
        '<span class="mk-rev__stem">' + esc(q.q) + '</span><span class="mk-rev__tag">' + (ok ? 'Correct' : (a === undefined ? 'Blank' : 'Missed')) + (S.flags[i] ? ' · flagged' : '') + '</span></summary><div class="mk-rev__body">' +
        '<p class="muted">' + esc(q.t) + ' · ' + esc(DOMAINS[dom(q.t)]) + '</p><ol class="mk-rev__opts">';
      q.o.forEach(function (o, k) {
        html += '<li class="' + (k === q.c ? 'is-right' : (k === a ? 'is-wrong' : '')) + '"><span class="mk-opt__letter">' + LETTERS[k] + '</span>' + esc(o) +
          (k === q.c ? ' <em>correct answer</em>' : (k === a ? ' <em>your answer</em>' : '')) + '</li>';
      });
      html += '</ol><p class="mk-rev__why"><strong>Why:</strong> ' + esc(q.e) + '</p></div></details>';
    });
    html += '</div><div class="button-row"><button class="button" data-act="home">' + esc(cfg('backLabel', 'Back to my exams')) + '</button>' +
      '<button class="button button--secondary" data-act="retake" data-form="' + FORM + '">' + esc(cfg('retakeLabel', 'Retake ' + fname(FORM))) + '</button></div></div>';
    app.innerHTML = html;
    window.scrollTo(0, app.getBoundingClientRect().top + window.scrollY - 90);
  }

  /* ============================== EVENTS ============================== */
  app.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'mk-opt') choose(parseInt(t.value, 10));
    if (t.dataset && t.dataset.act === 'flag') { S.flags[S.cur] = t.checked; if (!t.checked) delete S.flags[S.cur]; save(); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b || !(app.contains(b) || b.closest('.mk-modal'))) return;
    var act = b.dataset.act, f = b.dataset.form;
    if (act === 'flag') return;
    if (act === 'start') start(f, b.dataset.mode);
    else if (act === 'resume') resume(f);
    else if (act === 'restart' || act === 'retake') {
      modal('<h2 class="h3">Start ' + esc(fname(f)) + ' over?</h2><p>This clears your current answers for ' + esc(fname(f)) + '. Your past scores stay in your history.</p>' +
        '<div class="button-row"><button class="button" data-act="wipe" data-form="' + f + '">Yes, start over</button><button class="button button--secondary" data-act="close">Cancel</button></div>', 'Start over');
    }
    else if (act === 'wipe') { drop(key(f)); closeModal(); home(); }
    else if (act === 'results') { FORM = f; S = get(key(f), null); reviewFilter = 'all'; if (S) results(); }
    else if (act === 'prev') go(-1);
    else if (act === 'next') go(1);
    else if (act === 'check') { if (S.answers[S.cur] !== undefined) { S.checked[S.cur] = true; save(); question(); } }
    else if (act === 'map') map();
    else if (act === 'jump') { S.cur = parseInt(b.dataset.i, 10); save(); closeModal(); question(); }
    else if (act === 'finish') confirmFinish();
    else if (act === 'submit') submit(false);
    else if (act === 'close') closeModal();
    else if (act === 'filter') { reviewFilter = b.dataset.f; results(); document.getElementById('mk-review').scrollIntoView(); }
    else if (act === 'home') home();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (!S || S.submitted || document.querySelector('.mk-modal')) return;
    if (!app.querySelector('.mk-exam')) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'textarea' || (tag === 'input' && e.target.type === 'text') || e.metaKey || e.ctrlKey || e.altKey) return;
    var k = e.key.toLowerCase(), idx = ['1', '2', '3', '4'].indexOf(k);
    if (idx < 0) idx = ['a', 'b', 'c', 'd'].indexOf(k);
    if (idx > -1) { e.preventDefault(); choose(idx); }
    else if (k === 'arrowright' || k === 'n') { e.preventDefault(); go(1); }
    else if (k === 'arrowleft' || k === 'p') { e.preventDefault(); go(-1); }
    else if (k === 'f') { e.preventDefault(); S.flags[S.cur] = !S.flags[S.cur]; if (!S.flags[S.cur]) delete S.flags[S.cur]; save(); question(); }
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && S && !S.submitted && S.deadline && Date.now() >= S.deadline) submit(true);
  });

  if (CFG.lead) {
    var ls = document.getElementById('mk-lead-status'), state = ls ? ls.getAttribute('data-state') : '';
    if (!state && /[?&]customer_posted=true/.test(location.search)) state = 'ok';
    if (state === 'ok') put(LKEY, true);
    if (state) {
      var last = FORM_DEFS.map(function (d) { return d.id; }).filter(function (f) { var st = get(key(f), null); return st && st.submitted; })[0];
      if (last) {
        FORM = last; S = get(key(last), null); reviewFilter = 'all'; results();
        var r = document.getElementById('mk-review'); if (r) r.scrollIntoView();
        return;
      }
    }
  }

  if (!FORM_DEFS.some(function (d) { return FORMS[d.id].length; })) {
    app.innerHTML = '<p>Something went wrong loading the questions. Please refresh the page, and <a href="/pages/contact">let us know</a> if it keeps happening.</p>';
    return;
  }
  home();
})();
